module.exports = __webpack_public_path__ + "static/media/loader.4fa9e584.svg";